import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import ProtectedRoute from "./components/ProtectedRoute";
import AppLayout from "./layouts/AppLayout";

import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import DashboardPage from "./pages/DashboardPage";
import TransactionPage from "./pages/TransactionPage";
import HistoryPage from "./pages/HistoryPage";
import TransactionDetailPage from "./pages/TransactionDetailPage";
import ProfilePage from "./pages/ProfilePage";
import StatsPage from "./pages/StatsPage";
import AdminPage from "./pages/AdminPage";
import AdminUsersPage from "./pages/AdminUsersPage";
import WalletLedgerPage from "./pages/WalletLedgerPage";
import TransactionCatalogPage from "./pages/TransactionCatalogPage";
import DepositPage from "./pages/DepositPage";
import QRISPage from "./pages/QRISPage";
import AdminOperationsPage from "./pages/AdminOperationsPage";
import BonusWarungPage from "./pages/BonusWarungPage";
import DeveloperDashboardPage from "./pages/DeveloperDashboardPage";

import AdminProviderPage from './pages/AdminProviderPage';

function App() {
    return (
        <ThemeProvider>
            <AuthProvider>
                <BrowserRouter>
                    <Toaster position="top-center" richColors closeButton />
                    <Routes>
                        <Route path="/" element={<LandingPage />} />
                        <Route path="/login" element={<LoginPage />} />
                        <Route path="/login/rahasia-admin" element={<LoginPage adminMode />} />
                        <Route path="/login/developer" element={<LoginPage developerMode />} />
                        <Route path="/register" element={<RegisterPage />} />
                    <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
                            <Route path="/dashboard" element={<DashboardPage />} />
                            <Route path="/transaksi" element={<TransactionCatalogPage />} />
                            <Route path="/deposit" element={<DepositPage />} />
                            <Route path="/deposit/qris" element={<QRISPage />} />
                            <Route path="/transaksi/:type" element={<TransactionPage />} />
                            <Route path="/riwayat" element={<HistoryPage />} />
                            <Route path="/riwayat/:id" element={<TransactionDetailPage />} />
                            <Route path="/mutasi" element={<WalletLedgerPage />} />
                            <Route path="/profil" element={<ProfilePage />} />
                            <Route path="/statistik" element={<StatsPage />} />
                            <Route path="/bonus-warung" element={<BonusWarungPage />} />
                        </Route>

                        <Route path="/admin/provider/digiflazz" element={<ProtectedRoute><AdminProviderPage /></ProtectedRoute>} />
                        <Route
                            path="/admin/operasional"
                            element={<ProtectedRoute adminOnly><AdminOperationsPage /></ProtectedRoute>}
                        />
                        <Route
                            path="/developer"
                            element={<ProtectedRoute developerOnly><DeveloperDashboardPage /></ProtectedRoute>}
                        />
                        <Route
                            path="/admin"
                            element={
                                <ProtectedRoute adminOnly>
                                    <AdminPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/admin/users"
                            element={
                                <ProtectedRoute adminOnly>
                                    <AdminUsersPage />
                                </ProtectedRoute>
                            }
                        />
                    </Routes>
                </BrowserRouter>
            </AuthProvider>
        </ThemeProvider>
    );
}

export default App;
